import { apiSensedia } from '../api-sensedia';

export const downloadFiles = async (files: any[]) => {
  return (
    await apiSensedia.get(
      '/gestao-de-carteiras/carteira-previdencia-individual/carteira-recomendada',
      { params: { id: files[0]['id'] } }
    )
  ).data as string[];
};
